module.exports = __webpack_public_path__ + "img/tooth-pic.e3f2843c.jpg";